module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Clothes/Panties-db011a85a42274c99d79c28e5c6dc495.svg";